import type { CSSProperties } from 'react';

interface DimensionLabelProps {
  name: string;
  /** true = la fila es un comportamiento y necesita el nombre del fundamental como contexto. */
  isBehavior: boolean;
  fundamentalName: string;
  /** Color del fundamental; pinta el punto que antecede al nombre. */
  color?: string | null;
  /** Oculta el punto de color cuando el contenedor ya lo dibuja por su cuenta. */
  hasDot?: boolean;
}

/**
 * Nombre de una dimensión de reporte con su contexto.
 *
 * Un comportamiento ("Aprendiz", "Seguridad Psicológica") no se entiende suelto: se muestra
 * acompañado del fundamental del que cuelga. Un fundamental sin comportamientos se muestra solo.
 * Componente compartido por Resumen, Fundamentales y Generacional para que las tres pestañas
 * nombren las filas igual.
 */
export function DimensionLabel({
  name,
  isBehavior,
  fundamentalName,
  color,
  hasDot = true,
}: DimensionLabelProps) {
  const dotStyle: CSSProperties = { background: color ?? 'var(--gray-500)' };

  return (
    <span className="au-dim-label">
      {hasDot && <span className="au-dim-dot" style={dotStyle} />}
      <span className="au-dim-text">
        <span className="au-dim-name">{name}</span>
        {isBehavior && <span className="au-dim-parent">{fundamentalName}</span>}
      </span>
    </span>
  );
}
